<div *ngIf="type === notificationTypeEnum.MESSAGE" class="bk-notification__message">
    {{ messsage }}
</div>
<div *ngIf="type === notificationTypeEnum.ERROR" class="bk-notification__message bk-notification__error">
    <mat-icon>error_outline</mat-icon> {{ message }}
</div>
<div *ngIf="type === notificationTypeEnum.UPDATE" class="bk-notification__message bk-notification__update">
    <mat-spinner *ngIf="showSpinner" diameter="24"></mat-spinner>
    <mat-icon *ngIf="!showSpinner">cached</mat-icon> {{ message }}
</div>
